import { Container, createRoot } from "react-dom/client";
import { FactoryTracker } from "../components/FactoryTracker";

const root = createRoot(document.getElementById("root") as Container);

root.render(<FactoryTracker />);
